import { render, staticRenderFns } from "./ButtonsHolder.vue?vue&type=template&id=076229b2&scoped=true&"
import script from "./ButtonsHolder.vue?vue&type=script&lang=js&"
export * from "./ButtonsHolder.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsHolder.vue?vue&type=style&index=0&id=076229b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076229b2",
  null
  
)

export default component.exports